import { type FetchNftExternalAddressesParamsNetworkTypes, type NFTExternalAddress } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchExternalAddresses } from '../api';

export type UseExternalAddressesQueryOptions = Omit<
	UseQueryOptions<Array<NFTExternalAddress>, unknown, Array<NFTExternalAddress> | undefined>,
	'queryFn' | 'queryKey' | 'select'
>;

/**
 * @param networkTypes - | 'ethereum' | 'polygon' | 'cc1' | 'cc2' | 'socios_wallet' | 'bnb_smart_chain';
 * @returns NFTFormattedCollectibleDTO
 */
export const useExternalAddressesQuery = <TData = Array<NFTExternalAddress> | undefined>(
	networkTypes: Array<FetchNftExternalAddressesParamsNetworkTypes>,
	select: (data: Array<NFTExternalAddress> | undefined) => TData,
	options?: UseExternalAddressesQueryOptions
) =>
	useQuery({
		queryFn: () => fetchExternalAddresses({ 'networkTypes[]': networkTypes }),
		queryKey: ['recipients', networkTypes],
		select,
		...options,
		enabled: !!networkTypes && networkTypes.length > 0
	});
